// extracted by mini-css-extract-plugin
export default {"page-header":"defaultLayout_page-header__ATxnT","defaultLayout":"defaultLayout_defaultLayout__WJS2-","defaultLayout--title":"defaultLayout_defaultLayout--title__QcT8P"};